import React from 'react';
import './styles/projetos.css';
import beneDuCorte from './imgs/logoBene.png';
import magiaDosLivros from './imgs/magiadoslivros.png';
import ipcgdigital from './imgs/ipcdigital.png';
import { useSpring, animated } from '@react-spring/web';
import TopButton from './ScrollToTopButton';

function Projetos() {

    const animationProps = useSpring({
        from: { transform: 'translateY(100%)', opacity: 0 },
        to: { transform: 'translateY(0)', opacity: 1 },
        config: { tension: 150, friction: 20 }
    });

    return (
        <div className="home">
            <animated.div style={animationProps} className='welcomeCard'>
                <h1>Nossos <span className="green">Projetos</span></h1>
            </animated.div>

            <animated.div style={animationProps} className='welcomeCard'>
                <p>Na Dev´s <span className="green">Systems</span>, acreditamos que cada projeto é uma oportunidade de transformar ideias em realidade.
                    <br />Nossa equipe dedicada de profissionais, com expertise em diversas áreas de tecnologia, colabora para criar soluções inovadoras que atendem às necessidades únicas de nossos clientes.
                </p>
            </animated.div>

            {/* 🔹 Barbearia Lopes */}
            <div>
                <animated.div style={animationProps} className='welcomeCard'>
                    <h1>Barbearia Lopes</h1>
                </animated.div>
                <div>
                    <animated.div style={animationProps} className='welcomeCard'>
                        <a href="http://www.barbearia-lopes.kinghost.net/barbearia/?next=%2Fbarbearia%2Finicio" target="_blank" rel="noopener noreferrer">
                            <img className='bene' alt="Bene du Cort" src={beneDuCorte} />
                        </a>
                    </animated.div>
                </div>
            </div>

            <animated.div style={animationProps} className='welcomeCard'>
                <p>Barbearia Lopes é um projeto da Dev´s <span className="green">Systems</span> que oferece serviços de barbearia sob demanda, com foco na personalização completa para refletir a identidade do contratante.
                    <br />Os clientes podem escolher entre ser atendidos em casa ou visitar o barbeiro, com uma plataforma que permite agendamentos e escolhas personalizadas.
                    <br />Para os barbeiros, é uma oportunidade de expandir seus negócios, atendendo a uma clientela diversificada.
                    <br />O projeto visa oferecer uma experiência única e exclusiva de grooming, adaptada às necessidades específicas de cada cliente.
                </p>
            </animated.div>

            <hr />

            {/* 🔹 Magia dos Livros */}
            <div>
                <animated.div style={animationProps} className='welcomeCard'>
                    <h1>Magia dos Livros</h1>
                </animated.div>

                <animated.div style={animationProps} className='welcomeCard'>
                    <div className="projectContainer">
                        <a href="https://magiadoslivrosbh.com.br/" target="_blank" rel="noopener noreferrer">
                            <img className="projetos" alt="Magia dos Livros" src={magiaDosLivros} />
                        </a>
                    </div>
                </animated.div>
            </div>

            <animated.div style={animationProps} className='welcomeCard'>
                <p>Fundada em 2011, a <span className="green">Magia dos Livros</span> é uma empresa mineira que se tornou referência no fornecimento de livros para instituições públicas e escolares, especialmente no atendimento à Prefeitura de Belo Horizonte (PBH) e suas bibliotecas escolares.
                    <br />Localizada no coração da capital mineira, oferece um catálogo amplo e diversificado, reunindo títulos de editoras de todo o Brasil.
                    <br />Acreditamos que a biblioteca escolar é um espaço essencial de aprendizagem, capaz de despertar o prazer da leitura e formar cidadãos críticos e criativos.
                    <br />Nosso compromisso é contribuir para que cada biblioteca seja completa, inspiradora e transformadora.
                </p>
            </animated.div>

            <hr />

            {/* 🔹 Devs Systems */}
            <div>
                <animated.div style={animationProps} className='welcomeCard'>
                    <h1>ipcdigital</h1>
                </animated.div>

                <animated.div style={animationProps} className='welcomeCard'>
                    <div className="ipcdigital">
                        <a href="https://ipcdigital.org.br/" target="_blank" rel="noopener noreferrer">
                            <img className="projetos" alt="Magia dos Livros" src={ipcgdigital} />
                        </a>
                    </div>
                </animated.div>
            </div>

            <animated.div style={animationProps} className='welcomeCard'>
                <p>O <span className="green">IPCDigital</span> trabalha para preservar, valorizar e divulgar a cultura, as artes e o patrimônio histórico — material e imaterial — através da mediação digital.
                    <br />Utilizamos tecnologias e plataformas digitais para criar projetos criativos, acessíveis e alinhados às comunidades locais.
                    <br />Cada ação é guiada por pesquisa, respeito cultural e compromisso com a excelência na documentação e apresentação do patrimônio.
                </p>
            </animated.div>

            <hr />

            <TopButton />
        </div>
    );
}

export default Projetos;
